import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from './selectors';

type VisibleState = {
  isVisible: boolean;
};

type VisibleActions = {
  setVisible: () => void;
};

const store = create<
  VisibleState & VisibleActions,
  [['zustand/devtools', VisibleState & VisibleActions]]
>(
  devtools((set) => ({
    isVisible: true,
    setVisible: () => {
      set({ isVisible: false });
      setTimeout(() => {
        set({ isVisible: true });
      }, 1000);
    },
  }))
);

export const useVisibleStore = createSelectors(store);
